import dayjs from "dayjs";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { BoardDetail } from "@/components/molecules/BoardDetail";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { GET_DETAIL_NOTICE } from "@/common/querykeys";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import { Loading } from "@/components/atoms/Loading";

export const AlarmDetailPage = () => {
  /** 📍 URL Parameter Access */
  const { id } = useParams();

  /** 📡 API Layer */
  // 푸쉬 알림 특정 글 데이터 조회
  const { data: pushAlarmContent, isPending } = useQuery({
    queryKey: [GET_DETAIL_NOTICE, id],
    queryFn: async () => {
      return await request<any>({
        method: "GET",
        url: `/push-alarm/detail/${id}`,
      });
    },
  });

  return (
    <>
      {isPending ? (
        <Loading />
      ) : (
        <>
          <MainTemplate
            nav={false}
            subPage={false}
            menuBtn={false}
            buttonLeft={
              <Buttons
                type="button"
                size="headerTextIcon"
                layout="text"
                color="bright100"
                icon={<IconArrow />}
                label="뒤로"
                onClick={() => window.history.back()}
              />
            }
            pageTitle="Push 알림 보기"
          >
            <BoardDetail
              category={
                pushAlarmContent?.type || "게시글 타입을 설정하지 않았습니다."
              }
              title={pushAlarmContent?.title || "제목없음"}
              content={pushAlarmContent?.body}
              date={
                pushAlarmContent?.createdAt
                  ? dayjs(pushAlarmContent?.createdAt).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  : ""
              }
            />
          </MainTemplate>
        </>
      )}
    </>
  );
};
